import { Component } from '@angular/core';

@Component({
  selector: 'smhfs-fe-sidebar-notice',
  templateUrl: './sidebar-notice.component.html',
})
export class SidebarNoticeComponent {}
